/*
 * Mapping of progress steps for the progress bar.
 *
 * @typedef {Object} ProgressMapping
 * @property {string[]} label - The labels for the progress step. Index 0 = DTF, Index 1 = Spangle.
 * @property {number[]} percentage - The percentage range for the progress step. Index 0 = DTF, Index 1 = Spangle.
 * @property {number} interval - The interval in milliseconds for updating the progress bar.
 * @property {number} rate - The rate at which the progress bar should update.
 */
// eslint-disable-next-line import/prefer-default-export
export const DTF_PROGRESS_MAPPING = {
  upload_artwork: {
    label: ["Determining file type"],
    percentage: [15, 15],
    interval: [100],
    catchUpInterval: 20,
    rate: 0.1
  },
  validate_artwork: {
    label: ["Determining print area"],
    percentage: [75, 55],
    interval: [200, 250],
    catchUpInterval: 10,
    rate: 0.1
  },
  process_artwork: {
    label: ["Analyzing background"],
    percentage: [85, 60],
    interval: [100],
    catchUpInterval: 20,
    rate: 0.1
  },
  extract_bg_metadata: {
    label: ["Getting prices"],
    percentage: [90, 65],
    interval: [100, 500],
    catchUpInterval: 20,
    rate: 0.01
  },
  fetch_price: {
    label: ["Getting delivery date"],
    percentage: [100, 70],
    interval: [100, 700],
    rate: 0.1,
    catchUpInterval: 20,
    skipCatchUp: true
  },
  fetch_delivery_date: {
    label: ["", "Spangling image"],
    percentage: [100, 100],
    interval: [100],
    rate: 0.1,
    catchUpInterval: 20
  },
  spangle_image: {
    label: [""],
    percentage: [0, 100],
    interval: [100],
    rate: 0.1,
    catchUpInterval: 20
  }
};
